export default "__VITE_ASSET__ByC1oNSW__"